import { Box, Paper, Stack, Tab, Tabs } from '@mui/material'
import React, { lazy, useEffect } from 'react'
import { connect } from 'react-redux'
import DeliveryMemoFilter from './DeliveryMemoFilter'
import DeliveryMemoTable from './DeliveryMemoTable'
import { DeliveryMemoBottom1, DeliveryMemoBottom2 } from './DeliveryMemoBottom'
import * as sx from '../../common/stylesInline/report_daily_branch'
import { styled } from '@mui/system'
import { getTabLabels, getFilterNameMap, transparentStyle, getTransferData, transformData, pancardValidation, ValidateAadhaar, DownloadDeliveredTicketPdfs } from './const'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import PrintIcon from '@mui/icons-material/Print'
import PrintShortIcon from '@mui/icons-material/PrintOutlined'
import PdfIcon from '@mui/icons-material/PictureAsPdf'
import { useTheme } from '@mui/material/styles'
import { useSearchParams } from 'react-router-dom'
import ExcelIcon from '@mui/icons-material/FileCopy'
import moment from 'moment'
import { GetMOFPaymentUpdate, getDeliveryMemo, getDriverList, getIDProofList, getLrDetailsWIthBookingID, getVehicleList, updateAlertError, updateLoader, updateSelectedActivity } from '../../../store/common/common_action'
import DeliveryMemoTableTwo from './DeliveryMemoTableTwo'
import DeliveryMemoTableThree from './DeliveryMemoTableThree'
import { useState } from 'react'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { SuccessPopUp } from '../../common/snippets'
import { Grid } from '@mui/material'
import { getColumnDefsThreeA, getColumnDefsTwoA, getColumnDefsForExeFormat, exeColumnStyles } from './DeliveryMemoTableDefs'
import { columnStylesOne, getColumnDefsOneA, getColumnDefsThree, getColumnDefsTwo, getColumnDefsOneExcel, getColumnDefsOne } from './DeliveryMemoTableDefs'
import { callApiForArray, GetRequest } from '../../common/api'
import { delivery, urls } from '../../common/constants'
import { getValidationMessages } from '../../../i18n/validationMessages'
import { useTranslation } from '../../../i18n/I18nProvider'
import { focusElemnt, getDeliveryGst1, isEmpty, navigation1, navigation3, removeDuplicatesFromArray, isValueinObjectArray } from '../../common/helper'
import { BookingConfirm } from '../../common/bookingConfirm'
import DeliveryMemoTblPdf from './DeliveryMemoTblPdf'
import { callAddFontRobotoBold } from '../../common/font/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../common/font/font/Roboto-Medium-normal'
import { useAtom } from 'jotai'
import { destinationCityAtom, destinationCityListAtom, sourceCityAtom, sourceCityListAtom } from '../../common/jotaiState/deliverymemoStateAtoms'
import { activeDropAtom, inputLRNumberAtom, showDropAtom } from '../../common/jotaiState/deliveryStateAtoms'
import { alertAtom, deliveryPopupAtom, modalAtom } from '../../common/jotaiState/globalStateAtoms'
import LoaderModel from './loaderModel'
import { SAINI_TRAVELS, SAMAY_TRAVEL, TULSI_TRAVEL, LALA_EXPRESS, HANS_COMPANY_ID, GUJRAT_COMPANY_ID, DEMO_COMPANY } from '../../../helper/companyIdhardcode'
import {exportToExcel} from '../../common/hook'
import { makeTable } from '../Reports/analysisReport/pdfAutotable'
import Modal from '../../common/modal'
const Delivery = lazy(() => import('../DeliveryActivity'))

const StyledTabs = styled(Tabs)(({ theme }) => ({
  '& .MuiTabs-indicator': {
    height: 4,
    backgroundColor: theme.palette.primary.main,
  },
}))
const DeliveryMemo = (props) => {
  const { translations } = useTranslation()
  const dm = translations?.deliveryMemo || {}
  const cs = translations?.common || {}
  const error = getValidationMessages(translations)
  const tabLabels = getTabLabels(translations)
  const dynamicFilterNames = getFilterNameMap(translations)
  const columnDefsOneA = getColumnDefsOneA(translations)
  const columnDefsTwoA = getColumnDefsTwoA(translations)
  const columnDefsThreeA = getColumnDefsThreeA(translations)
  const columnDefsOne = getColumnDefsOne(translations)
  const columnDefsTwo = getColumnDefsTwo(translations)
  const columnDefsThree = getColumnDefsThree(translations)
  const columnDefsOneExcel = getColumnDefsOneExcel(translations)
  const columnDefsForExeFormat = getColumnDefsForExeFormat(translations)
  const { data, getVehicleList, getIDProofList, GetMOFPaymentUpdate, updateAlertError, updateLoader, updateSelectedActivity } = props
  const { common } = data
  const { loginData, deliveryMemoList, brnchList, driverInfo, vehicleList, companySettings: companySettingsL, gstConfig } = common
  const companySettings = companySettingsL?.[0] || {}
  const { intCompanyID, intBranchID } = loginData
  const { HasGSTOnDelivery = false, HasContactNoCompulsory = false } = companySettings
  const { DefaultCurrencyID } = companySettings
  const isCompanyTwelve = intCompanyID === SAINI_TRAVELS
  const isGujaratCompany = intCompanyID === GUJRAT_COMPANY_ID
  const hiddenCompanyTwelveDeliveryCols = ['AdditionalDeliveryCartage', 'DeliveryChg', 'ExtraHamli', 'DemurrageChg', 'Discount', 'DeliveryGST']
  const senderColumnDefOneA = { headerName: dm.senderNameSenderNo || 'Sender Name\nSender No.', exportHead: dm.senderNameSenderNo || 'Sender Name\nSender No.', field: 'sendSender', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } }
  const consignmentColumnDefOneA = { headerName: dm.consignment || 'Consignment', exportHead: dm.consignment || 'Consignment', field: 'Consignment', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } }
  const columnStylesOneCompanyTwelve = {
    ...columnStylesOne,
    7: { halign: 'left', font: 'Roboto', fontSize: 16 },
    8: { halign: 'left', font: 'Roboto', fontSize: 16 },
  }
  const isSamayOrTulsiTravel = loginData?.intCompanyID === TULSI_TRAVEL || loginData?.intCompanyID === SAMAY_TRAVEL;
  const showSenderColumns = [LALA_EXPRESS, SAMAY_TRAVEL, TULSI_TRAVEL].includes(loginData?.intCompanyID)
  const shouldHideDeliveryChargeColumns = isSamayOrTulsiTravel || isCompanyTwelve;
  const shouldHideDeliveryGstColumn = isCompanyTwelve || showSenderColumns;
  const columnShowIfCtx = { isCompanyTwelve, shouldHideDeliveryChargeColumns, shouldHideDeliveryGstColumn, isGujaratCompany, showSenderColumns }
  const visibleCols = (cols) => cols.filter((col) => !col.showIf || col.showIf(columnShowIfCtx))
  const getCompanyColumnDefsOneA = () => {
    const baseDefs = visibleCols(columnDefsOneA)
    if (!isCompanyTwelve) return baseDefs
    const columnDefsWithSender = [...baseDefs.slice(0, 5), senderColumnDefOneA, ...baseDefs.slice(5)]
    const unitsColumnIndex = columnDefsWithSender.findIndex((col) => col.field === 'Units')
    const columnDefsWithConsignment = [
      ...columnDefsWithSender.slice(0, unitsColumnIndex),
      consignmentColumnDefOneA,
      ...columnDefsWithSender.slice(unitsColumnIndex),
    ]
    return columnDefsWithConsignment.filter((col) => !hiddenCompanyTwelveDeliveryCols.includes(col.field))
  }
  const { getIdProof, methodOfPayment, partyList, lrDetailsData } = common
  const { getDeliveryMemo, getDriverList, getLrDetailsWIthBookingID } = props
  const theme = useTheme()
  const [, setSearchParams] = useSearchParams()
  const [selectedTab, setSelectedTab] = useState(0)
  const [isExpanded, setIsExpanded] = useState(false)
  const [memoFromDate, setMemoFromDate] = useState(moment(new Date()))
  const [memoToDate, setMemoToDate] = useState(moment(new Date()))
  const [isShowAllLRs, setIsShowAllLRs] = useState(0)
  const [tableData, setTableData] = useState([])
  const [isPdfLoaded, setIsPdfLoaded] = useState(false)
  const [excelData, setexcelData] = useState([])
  const [sourceCity, setSourceCity] = useAtom(sourceCityAtom)
  const [destinationCity, setDestinationCity] = useAtom(destinationCityAtom)
  const [, setSourceCityListData] = useAtom(sourceCityListAtom)
  const [, setDestinationCityListData] = useAtom(destinationCityListAtom)
  const [, setDeliveryInputLrNumber] = useAtom(inputLRNumberAtom)
  const [, setDeliveryShowDrop] = useAtom(showDropAtom)
  const [, setDeliveryActiveDrop] = useAtom(activeDropAtom)
  const [MOPList, setMOPList] = useState([])
  const filters = {
    PaymentType: '',
    ChallanNo: '',
    LRNO: '',
    ManualLRNo: '',
    Sender: '',
    SenderMobileNo: '',
    SenderGSTN: '',
    SenderEmailID: '',
    RecName: '',
    RecMobileNo: '',
    ReceiverEmailID: '',
    ReceiverGSTN: '',
    PinCode: '',
  }
  const [moreFilter, setMoreFilter] = useState(filters)
  const [appliedMoreFilter, setAppliedMoreFilter] = useState({})
  const [filterheight, setFilterHeight] = useState(0)
  const [bulkDeliveryCheck, setBulkDeliveryCheck] = useState(false)
  const [reciverName, setRecieverName] = useState('')
  const [reciverPhone, setReceiverPhone] = useState('')
  const [selectedRecIdType, setselectedRecIdType] = useState(null)
  const [ReIdNumber, setReIdNumber] = useState('')
  const [selectedMOP, setSelectedMOP] = useState('')
  const [selectedParty, setSelectedParty] = useState(null)
  const [selectedVehicle, setSelectedVehicle] = useState(null)
  const [remarks, setRemarks] = useState('')
  const [selectedLrs, setSelectedLrs] = useState([])
  const [deliveryPopup,setDeliveryPopup] = useAtom(deliveryPopupAtom)

  //tab two data
  const [brnchForDelivery, setBrnchForDelivery] = useState('')
  const [trnsfrVehicle, setTrnsfrVehicle] = useState('')
  const [driverName, setDriverName] = useState('')
  const [remark, setRemark] = useState('')
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [showConfirmationTwo, setShowConfirmationTwo] = useState(false)
  const [showDeliveryPrintConfirmation, setShowDeliveryPrintConfirmation] = useState(false)
  const [deliveredPrintData, setDeliveredPrintData] = useState({ response: null, lrs: [] })
  const [showLRDetails, setShowLRDetails] = useState(false)
  const [clickBookingId, setClickedBookingID] = useState(false)
  const [showMore, setShowMore] = useState(false)
  const [tillDate, setTillDate] = useState(false)
  const [showAll, setShowAll] = useState(false)
  const [resetFilter, setResetFilter] = useState(false);
  const [resetMainFilter, setResetMainFilter] = useState(false);
  const [checkboxStates, setCheckboxStates] = useState({});
  //more filter
  const [paymentTypeListData, setPaymentListData] = useState([])
  const [challanNoListData, setChallanNoListData] = useState([])
  const [lrNoListData, setLrNoListData] = useState([])
  const [offlineLrNoListData, setOfflineLrNoListData] = useState([])
  const [senderListData, setSenderListData] = useState([])
  const [senderMobileNoListData, setSenderMobileNoListData] = useState([])
  const [senderGSTNListData, setSenderGSTNListData] = useState([])
  const [senderEmailIDListData, setSenderEmailIDListData] = useState([])
  const [recNameListData, setRecNameListData] = useState([])
  const [recMobileNoListData, setRecMobileNoListData] = useState([])
  const [receiverEmailIDListData, setReceiverEmailIDListData] = useState([])
  const [receiverGSTNListData, setReceiverGSTNListData] = useState([])
  const [pinCodeListData, setPinCodeListData] = useState([])
  const [modal, setModal] = useAtom(modalAtom)
  const [, setAlert] = useAtom(alertAtom)
  const [cityListData, setCityListData] = useState([])
  const [deliveryMemoData, setDeliveryMemoData] = useState([])
  
  const criteriaHeaders = [
    { field: 'fromDate', header: dm.fromMemoDate || 'From Memo Date', textAlign: 'left' },
    { field: 'toDate', header: dm.toMemoDate || 'To Memo Date', textAlign: 'left' },
    { field: 'sourceCity', header: dm.sourceCity || 'Source City', textAlign: 'left' },
    { field: 'destinationCity', header: dm.destinationCity || 'Destination City', textAlign: 'left' },
    { field: 'reportName', header: dm.report || 'Report', textAlign: 'left' },
    ...Object.keys(appliedMoreFilter).map(key => ({
      field: key,
      header: dynamicFilterNames[key] || key,
      textAlign: 'left'
    }))
  ]

  const criteriaData = {
    fromDate: moment(memoFromDate).format('DD-MM-YYYY'),
    toDate: moment(memoToDate).format('DD-MM-YYYY'),
    sourceCity: sourceCity.map(item => item.sourceCityList).join(', '),
    destinationCity: destinationCity?.DestinationCity || '',
    reportName: tabLabels[selectedTab],
    ...appliedMoreFilter,
    dataType: 'entry'
  }
  const showSuccessAndReload = (msg, onClose = reloadTable) => {
    setAlert({
      show: true,
      msg,
      success: true,
      close: () => {
        setAlert({ show: false, msg: '' })
        onClose()
      },
    })
  }

  const memoFilterData = {
    isExpanded, memoToDate, memoFromDate, moreFilter, appliedMoreFilter, showMore, tillDate, showAll, resetFilter, resetMainFilter,
    paymentTypeListData, challanNoListData, lrNoListData, offlineLrNoListData, senderListData, senderMobileNoListData, senderMobileNoListData, senderGSTNListData, senderGSTNListData, senderEmailIDListData, recNameListData,
    recMobileNoListData, receiverEmailIDListData, receiverGSTNListData, pinCodeListData
  }
  const memoFilterMethods = {
    setMemoFromDate, setMemoToDate, setMoreFilter, setAppliedMoreFilter, setShowMore, setTillDate, setShowAll, setResetFilter, setPaymentListData, setChallanNoListData, setLrNoListData, setIsPdfLoaded,
    setOfflineLrNoListData, setSenderListData, setSenderMobileNoListData, setSenderGSTNListData, setSenderEmailIDListData, setRecNameListData, setRecMobileNoListData, setReceiverEmailIDListData, setReceiverGSTNListData, setPinCodeListData, setIsExpanded
  }
  const bulkDeliverMsg = selectedLrs.length === 1 ? (dm.lrDeliveredSuccessfully || 'LR Delivered Successfully') : (dm.allLrsDeliveredSuccessfully || 'All LRs Delivered Successfully!')
  const bulkDeliver = () => {
    const deliveredLrs = [...selectedLrs]
    const commonData = {
      ReceivedBy: reciverName || '',
      RecMobileNo: reciverPhone || '',
      SenderIDProofID: selectedRecIdType?.IDProofid || 0,
      IDProof: ReIdNumber || '',
      PaymentType: selectedMOP?.ModeID || 0,
      ReceivingPartyID: selectedParty?.PartyID || 0,
      VehicleNo: selectedVehicle?.VehicleNo || '',
      Remarks: remarks,
      intUserID: loginData.intUserID,
    }
    const dataArray = transformData(deliveredLrs, commonData, loginData)
    updateLoader(true)
    callApiForArray(urls.deliveryWebInsert, dataArray)
      .then((res) => {
        // if (loginData?.intCompanyID === HANS_COMPANY_ID) {
          // await DownloadDeliveredTicketPdfs(res, selectedLrs, { intBranchID, loginData })
        // }
        updateLoader(false)
        const [responses = []] = Array.isArray(res) ? res : []
        const allSuccess = responses.length > 0 && responses.every((r) => r?.status === 'Success')
        if (allSuccess) {
          setDeliveredPrintData({ response: res, lrs: deliveredLrs })
          showSuccessAndReload(bulkDeliverMsg, () => setShowDeliveryPrintConfirmation(true))
        } else {
          const errMsg =
            responses.find((r) => r?.status !== 'Success')?.ErrMessage ||
            dm.lrDeliveryFailed ||
            'Delivery Failed!'
          updateAlertError({ show: true, msg: errMsg })
        }
      })
      .catch((err) => {
        updateLoader(false)
        console.log(err)
      })
  }
  const printDeliveredTickets = async () => {
    const { response, lrs } = deliveredPrintData
    setShowDeliveryPrintConfirmation(false)
    updateLoader(true)
    try {
      await DownloadDeliveredTicketPdfs(response, lrs, { intBranchID, loginData, printSingle: lrs.length === 1 })
      updateLoader(false)
      reloadTable()
    } catch (err) {
      updateLoader(false)
      console.log(err)
      reloadTable()
    }
  }
  const closeDeliveredTicketPrint = () => {
    setShowDeliveryPrintConfirmation(false)
    setDeliveredPrintData({ response: null, lrs: [] })
    reloadTable()
  }
  const bulkTransferMsg = selectedLrs.length === 1 ? (dm.lrTransferredSuccessfully || 'LR Transferred Successfully') : (dm.allLrsTransferredSuccessfully || 'All LRs Transferred Successfully!')
  const bulkDeliverTwo = () => {
    const commonData = {
      BranchForDelTrans: brnchForDelivery.BranchID || 0,
      VehicleNo: trnsfrVehicle?.VehicleNo || '',
      Remarks: remark,
      driverName: driverName.DriverConductorID || 0,
      toCity: brnchForDelivery.CityID,
      intUserID: loginData.intUserID,
      intCompanyID: loginData.intCompanyID,
    }
    const dataArray = getTransferData(selectedLrs, commonData)
    updateLoader(true)
    callApiForArray(urls.getBranchTransfer, dataArray)
      .then((res) => {
        updateLoader(false)
        if (typeof res === 'object' && res[0][0]?.status === true) {
          showSuccessAndReload(bulkTransferMsg)
        } else {
          updateLoader(false)
          updateAlertError({ show: true, msg: dm.lrTransferFailed || 'LR Transfer Failed!', success: false })
        }
      })
      .catch((err) => {
        updateLoader(false)
        console.log(err)
      })
  }
  const handleIdProofInput = (e) => {
    let idValue = e.target.value;
    if (idValue !== '' && selectedRecIdType.IDProof === 'PAN Card') {
      if (pancardValidation(idValue)) {
        setReIdNumber(idValue)
      } else {
        setReIdNumber('')
        updateAlertError({ show: true, msg: dm.invalidPanCardNumber || 'Invalid PAN Card Number', nextId: 'memoDeliveryReceiverIdNumber' })
      }
    } else if (idValue !== '' && selectedRecIdType.IDProof === 'Aadhar Card') {
      if (ValidateAadhaar(idValue)) {
        setReIdNumber(idValue)
      } else {
        setReIdNumber('')
        updateAlertError({ show: true, msg: dm.invalidAadhaarNumber || 'Invalid Aadhaar Number', nextId: 'memoDeliveryReceiverIdNumber' })
      }
    } else {
      if (idValue !== '') {
        setReIdNumber(idValue)
      }
    }
  }

  const resetValues = () => {
    setReIdNumber('')
    updateAlertError({ show: false, msg: '' })
    focusElemnt('memoDeliveryReceiverIdNumber')
  }
  useEffect(() => {
    if (sourceCity.length) {
      setCityListData(
        removeDuplicatesFromArray(sourceCity.map((val) => ({
          loaded: 0,
          data: [],
          id: val.id,
          name: val.sourceCityList,
        })),'id')
      )
    }
  }, [sourceCity])
  useEffect(() => {
    if (deliveryMemoList?.length !== 0) {
      const allOption = { sourceCityList: dm.all || 'All', id: 0 }
      const newSourceCityListData = deliveryMemoList
        .reduce(
          (acc, item) => {
            if (!acc.seenIds.has(item.SourceCityID)) {
              acc.result.push({
                sourceCityList: item.SourceCity,
                id: item.SourceCityID,
              })
              acc.seenIds.add(item.SourceCityID)
            }
            return acc
          },
          { result: [], seenIds: new Set() }
        )
        .result.sort((a, b) => a.sourceCityList.localeCompare(b.sourceCityList))
      if ([GUJRAT_COMPANY_ID, SAINI_TRAVELS].includes(loginData?.intCompanyID)) {
        if (newSourceCityListData?.length > 1) {
          setSourceCityListData([allOption, ...newSourceCityListData])
        } else {
          setSourceCityListData(newSourceCityListData)
        }
      } else {
        setSourceCityListData(newSourceCityListData)
      }
      setSourceCity([newSourceCityListData[0]])

      const newDestinationCityListData = [...(deliveryMemoList || [])]
        .reduce(
          (acc, item) => {
            if (!acc.seenIds.has(item.DestinationCityID)) {
              acc.result.push({
                DestinationCity: item.DestinationCity,
                DestinationCityID: item.DestinationCityID,
              })
              acc.seenIds.add(item.DestinationCityID)
            }
            return acc
          },
          { result: [], seenIds: new Set() }
        )
        .result.sort((a, b) => a.DestinationCity.localeCompare(b.DestinationCity))
      setDestinationCityListData(newDestinationCityListData)
      setDestinationCity(newDestinationCityListData[0])
    } else {
      setResetMainFilter(!resetMainFilter)
      setSourceCityListData([])
      setDestinationCityListData([])
      setSourceCity([])
      setDestinationCity({})
    }
  }, [deliveryMemoList])

  useEffect(() => {
    if (!isEmpty(loginData)) {
      getVehicleList(loginData)
      getDriverList(loginData)
      getIDProofList(loginData)
      GetMOFPaymentUpdate({ intBranchID: loginData?.intBranchID })
    }
  }, [loginData])
  useEffect(() => {
    if (selectedLrs.length > 1) setBulkDeliveryCheck(true)
    else setBulkDeliveryCheck(false)
  }, [selectedLrs])
  const getFinalAmount = (data, DeliveryGST = 0, Discount = 0) => {
    const baseCharges =
      (+data?.AdditionalDeliveryCartage || 0) + //delivery cartage
      (+data?.HomeDeliveryChg || 0) + //hamali charge
      // (+data?.DeliveryChg || 0) +
      (+data?.ExtraHamli || 0) + //op hamali charge
      (+data?.DemurrageChg || 0) +
      (+DeliveryGST || 0) -
      (+Discount || 0)

    if ([2, 4, 7, 9].includes(data?.PaymentTypeID)) {
      return (+data?.TotalDues || 0) + baseCharges
    }
    return baseCharges
  }
  useEffect(() => {
    if (methodOfPayment?.Data?.Table?.length > 0) {
      setMOPList(methodOfPayment?.Data?.Table)
    } else {
      setMOPList([])
    }
  }, [methodOfPayment?.Data?.Table])

  useEffect(() => {
    if (selectedLrs?.length > 0 && selectedTab === 0) {
      switch (selectedLrs?.[0]?.PaymentTypeID) {
        case 1:
        case 6:
        case 8:
        case 9:
          let newList = methodOfPayment?.Data?.Table?.filter((item) => item?.ModeID !== 2)
          setMOPList(newList)
          setSelectedMOP(methodOfPayment?.Data?.Table?.find((item) => item?.ModeID === 1))
          //set selectedMOP to cash
          //remove credit option from list
          break;
        case 2:
        case 4:
        case 7:
          setMOPList(methodOfPayment?.Data?.Table)
          setSelectedMOP(methodOfPayment?.Data?.Table?.find((item) => item?.ModeID === 1))
          //set selectedMOP to cash
          break;
        case 5:
        case 10:
          setMOPList(methodOfPayment?.Data?.Table)
          setSelectedMOP(methodOfPayment?.Data?.Table?.find((item) => item?.ModeID === 2))
          //set selectedMOP to credit and disable
          //set selectedMOP to party disabled 
          break;
        default:
          setMOPList(methodOfPayment?.Data?.Table)
          setSelectedMOP('')
      }
    }

  }, [selectedLrs])

  const getTableInfo = (arr) => {
    return arr.map((item, i) => {
      const am = item.DeliveryChg + item.DemurrageChg
      const DeliveryGST = getDeliveryGst1(intCompanyID, HasGSTOnDelivery, am, 0.18, item.DeliveryGST, gstConfig, item).toFixed(2)
      return {
        ...item,
        srNo: i + 1,
        ReceiptDate: moment(item.ReceiptDate).format('DD-MM-YYYY'),
        brnchForDelivery: '',
        Discount: 0,
        DeliveryGST,
        finalAmount: getFinalAmount(item, DeliveryGST, 0),
        DescriptionDet: (item.DescriptionDet || item.Consignment || '').toString().trim(),
      }
    })
  }

  const reloadTable = () => {
    setDeliveredPrintData({ response: null, lrs: [] })
    setShowMore(false);
    setResetFilter(false);
    setTimeout(() => {
      setResetFilter(true)
    }, 100);
    setMoreFilter(filters);
    setIsExpanded(false);
    setIsPdfLoaded(false)
    setBrnchForDelivery('');
    setTrnsfrVehicle('')
    setDriverName('')
    setRemark('')
    setRecieverName('')
    setReceiverPhone('')
    setselectedRecIdType(null)
    setReIdNumber('')
    setSelectedMOP('')
    setSelectedParty(null)
    setSelectedVehicle(null)
    setRemarks('')

    setSelectedLrs([])
    setTableData([]);
    setAppliedMoreFilter({});

    setPaymentListData([])
    setChallanNoListData([])
    setLrNoListData([])
    setOfflineLrNoListData([])
    setSenderListData([])
    setSenderMobileNoListData([])
    setSenderGSTNListData([])
    setSenderEmailIDListData([])
    setRecNameListData([])
    setRecMobileNoListData([])
    setReceiverEmailIDListData([])
    setReceiverGSTNListData([])
    setPinCodeListData([])
    handleGenerate()
    setBulkDeliveryCheck(true)
    setTimeout(() => {
      setBulkDeliveryCheck(false)
    }, 100);
    updateAlertError({ show: false, msg: '' })
    focusElemnt('memoGenerate')
  }
  const resetTabData = () => {
    setMemoFromDate(moment(new Date()))
    setMemoToDate(moment(new Date()))
    setTillDate(false)
    setShowAll(false)
    setShowMore(false)
    setIsPdfLoaded(false)
    setSourceCity([])
    setDestinationCity({})
    setSourceCityListData([])
    setDestinationCityListData([])
    setResetFilter(false);
    setTimeout(() => {
      setResetFilter(true)
    }, 100);
    setResetMainFilter(false);
    setTimeout(() => {
      setResetMainFilter(true)
    }, 100);
    setMoreFilter(filters);
    setIsExpanded(false);
    setBrnchForDelivery('');
    setTrnsfrVehicle('')
    setDriverName('')
    setRemark('')
    setRecieverName('')
    setReceiverPhone('')
    setselectedRecIdType(null)
    setReIdNumber('')
    setSelectedMOP('')
    setSelectedParty(null)
    setSelectedVehicle(null)
    setRemarks('')
    setBulkDeliveryCheck(true)
    setTimeout(() => {
      setBulkDeliveryCheck(false)
    }, 100);
    setSelectedLrs([])
    setTableData([]);
    setAppliedMoreFilter({});
    setCheckboxStates({})

    setPaymentListData([])
    setChallanNoListData([])
    setLrNoListData([])
    setOfflineLrNoListData([])
    setSenderListData([])
    setSenderMobileNoListData([])
    setSenderGSTNListData([])
    setSenderEmailIDListData([])
    setRecNameListData([])
    setRecMobileNoListData([])
    setReceiverEmailIDListData([])
    setReceiverGSTNListData([])
    setPinCodeListData([])
    updateAlertError({ show: false, msg: '' })
    setMOPList([])
    setexcelData([])
  }

  const updateSelectedList = (e, data, selectedLrs, setSelectedLrs) => {
    if (e.target.checked) {
      setSelectedLrs([...selectedLrs, data])
      setCheckboxStates({ ...checkboxStates, [data.BookingID]: true });
      // if (selectedLrs?.length === 0 || selectedLrs?.[0]?.PaymentTypeID === data?.PaymentTypeID) {
      //   setSelectedLrs([...selectedLrs, data])
      //   setCheckboxStates({ ...checkboxStates, [data.BookingID]: true });
      // } else {
      //   updateAlertError({ show: true, msg: 'Please Select LR With Same Payment Type', nextId: '' })
      //   setCheckboxStates({ ...checkboxStates, [data.BookingID]: false });
      // }
    }
    else {
      if (selectedLrs.length === 1) {
        if (selectedTab === 0) {
          setRecieverName('')
          setReceiverPhone('')
          setselectedRecIdType(' ')
          setReIdNumber('')
          setSelectedMOP('')
          setSelectedParty(null)
          setSelectedVehicle(null)
          setRemarks('')
          setSelectedLrs([])
          setCheckboxStates({})
        } else {
          setBrnchForDelivery('')
          setTrnsfrVehicle('')
          setDriverName('')
          setRemark('')
          setSelectedLrs([])
        }
        setCheckboxStates({ ...checkboxStates, [data.BookingID]: false });
      } else {
        setSelectedLrs(selectedLrs.filter((obj) => obj.BookingID !== data.BookingID))
        setCheckboxStates({ ...checkboxStates, [data.BookingID]: false });
      }
    }
  }
  const updateSelectedList1 = (e, data, selectedLrs, setSelectedLrs) => {
    if (e.target.checked) {
      setSelectedLrs([...selectedLrs, data])
    }
    else {
      if (selectedLrs.length === 1) {
        if (selectedTab === 0) {
          setRecieverName('')
          setReceiverPhone('')
          setselectedRecIdType(' ')
          setReIdNumber('')
          setSelectedMOP('')
          setSelectedParty(null)
          setSelectedVehicle(null)
          setRemarks('')
          setSelectedLrs([])
        } else {
          setBrnchForDelivery('')
          setTrnsfrVehicle('')
          setDriverName('')
          setRemark('')
          setSelectedLrs([])
        }
      } else {
        setSelectedLrs(selectedLrs.filter((obj) => obj.BookingID !== data.BookingID))
      }
    }
  }
  const handleTabChange = (event, newValue) => {
    resetTabData()
    setSelectedTab(newValue)
    setIsExpanded(false)
  }
  const handleGenerate = async () => {
    if (sourceCity?.length === 0) {
      updateAlertError({ show: true, msg: dm.pleaseSelectSourceCity || 'Please Select Source City', nextId: '' })
      return
    }
    const object = {
      CompanyId: loginData.intCompanyID,
      BranchId: loginData.intBranchID,
      FromDate: memoFromDate.format('YYYY-MM-DD'),
      ToDate: memoToDate.format('YYYY-MM-DD'),
      DestinationCityID: destinationCity.DestinationCityID,
      UserId: loginData.intUserID,
      Mode: selectedTab + 1,
      IsShowAllLRs: isShowAllLRs,
      IsDelivered: 0,
    }
    const payloadList = sourceCity.map((item) => ({ ...object, SourceCityID: item.id }))
    setModal('loaderModal')
    const memoDataList = []
    for (let i = 0; i < sourceCity.length; i++) {
      const id = sourceCity[i].id
      setCityListData((prevList) => prevList.map((item) => (item.id === id ? { ...item, loaded: 1 } : item)))
      const res = await GetRequest(urls.getDeliveryMemoData, payloadList[i])
      setCityListData((prevList) => prevList.map((item) => (item.id === id ? { ...item, loaded: 2 } : item)))
      const memoData = res?.Data?.Table || []
      memoDataList.push(...memoData)
      if (id === 0) {
        break
      }
    }
    setDeliveryMemoData(memoDataList)
    setTableData(getTableInfo(memoDataList))
    setModal('')
    setIsExpanded(true)
  }

  const getFilter = () => {
    const object = {
      CompanyId: loginData.intCompanyID,
      BranchId: loginData.intBranchID,
      CityId: loginData.intBranchCityID,
      FromDate: memoFromDate.format('YYYY-MM-DD'),
      ToDate: memoToDate.format('YYYY-MM-DD'),
      UserId: loginData.intUserID,
      Mode: selectedTab + 1,
      IsShowAllLRs: !tillDate && !showAll ? 0 : isShowAllLRs, // 1 if show all pending lrs is checked , 0 if tilldate is selected.
      IsDelivered: 0,
    }
    getDeliveryMemo(object, cs.noDataFound)
  }

  const backToScreenView = () => {
    setIsPdfLoaded(false)
  }

  const IsLRSelected = (targetLrNo) => {
    return selectedLrs.some(obj => obj.LRNO === targetLrNo)
  }
  const getPdfTableBody = (id = 0) => {
    let newData = []
    let selTableData = []
    const upData = selectedLrs.map((item) => ({ ...item, PaymentTypeVehicle: item.PaymentType }))
    if (selectedLrs.length > 0 && id === 1) {
      selTableData = upData;
    } else {
      selTableData = tableData;
    }
    if (selectedTab === 0) {
      selTableData.map((item, index) => {
        let isSelected = IsLRSelected(item.LRNO)
        let pTypeVehicle = '';
        let rcvrByNum = ''
        let idProof = ''
        if (isSelected) {
          if (reciverName !== '') {
            rcvrByNum = reciverName
          }
          if (reciverPhone !== '') {
            rcvrByNum = rcvrByNum + '\n' + reciverPhone
          }
          if (selectedRecIdType?.IDProof !== '') {
            idProof = selectedRecIdType?.IDProof
          }
          if (ReIdNumber !== '') {
            idProof = idProof + '\n' + ReIdNumber
          }
        } else {
          pTypeVehicle = item.PaymentType
        }
        newData[index] = {
          srNo: item.srNo,
          LRNO: item.LRNO,
          LRNOManual: item.LRNO + '\n' + item.ManualLRNo,
          PaymentType: item.PaymentType,
          PaymentTypeVehicle: item.PaymentType,
          SourceCity: item.SourceCity,
          SrCityBranch: item.SourceCity + '\n' + item.SourceBranch,
          DestinationCity: item.DestinationCity,
          DstCityBranch: item.DestinationCity + '\n' + item.DestinationBranch,
          Sender:item.Sender,
          SenderMobileNo: item.SenderMobileNo,
          sendSender: item.Sender + '\n' + item.SenderMobileNo,
          RecName: item.RecName ,
          RecMobileNo: item.RecMobileNo,
          sendRec: item.RecName + '\n' + item.RecMobileNo,
          rcvDateChallan: item.ReceiptDate + '\n' + item.ChallanNo,
          Consignment: item.Consignment,
          DescriptionDet: (item.DescriptionDet || item.Consignment || '').toString().trim(),
          rcvrByNo: rcvrByNum,
          idProofNo: idProof,
          Units: item.Units,
          TotalDues: item.TotalDues,
          AdditionalDeliveryCartage: item.AdditionalDeliveryCartage,
          HamaliCharges: item.HamaliCharges,
          DeliveryChg: item.DeliveryChg,
          ExtraHamli: item.ExtraHamli,
          DemurrageChg: item.DemurrageChg,
          Discount: item.Discount,
          DeliveryGST: item.DeliveryGST,
          finalAmount: item.finalAmount,
          dataType: 'entry'
        }
      })
    } else if (selectedTab === 1) {
      tableData.map((item, index) => {
        let isSelected = IsLRSelected(item.LRNO)
        newData[index] = {
          srNo: item.srNo,
          LRNOManual: item.LRNO + '\n' + item.ManualLRNo,
          PaymentTypeDate: item.PaymentType + '\n' + item.ReceiptDate,
          DescriptionDet: (item.DescriptionDet || item.Consignment || '').toString().trim(),
          DstCityBr: item.DestinationCity + '\n' + item.DestinationBranch,
          Sender: item.Sender,
          SenderMobileNo: item.SenderMobileNo,
          sendSender: item.Sender + '\n' + item.SenderMobileNo,
          SrCityBranch: item.SourceCity + '\n' + item.CurrentBranch,
          Units: item.Units,
          TotalDues: item.TotalDues,
          BranchForDelTrans: isSelected ? brnchForDelivery?.BranchName : '',
          TransByVehicleNo: isSelected ? trnsfrVehicle?.VehicleNo : '',
          DriverName: isSelected ? driverName?.DriverConductorName : '',
          Remarks: isSelected ? remark : '',
          dataType: 'entry'
        }
      })
    } else if (selectedTab === 2) {
      tableData.map((item, index) => {
        newData[index] = {
          srNo: index + 1,
          LRNOManual: item.LRNO + '\n' + item.ManualLRNo,
          PaymentTypeDate: item.PaymentType + '\n' + item.ReceiptDate,
          DescriptionDet: (item.DescriptionDet || item.Consignment || '').toString().trim(),
          DstCityBr: item.DestinationCity + '\n' + item.DestinationBranch,
          Sender: item.Sender,
          SenderMobileNo: item.SenderMobileNo,
          sendSender: item.Sender + '\n' + item.SenderMobileNo,
          SrCityBranch: item.SourceCity + '\n' + item.CurrentBranch,
          Units: item.Units,
          TotalDues: item.TotalDues,
          OtherBranchInchargeName: item.OtherBranchInchargeName,
          OtherBranchIncContactNo: item.OtherBranchIncContactNo,
          VehicleNo: item.VehicleNo,
          DriverNoName: item.DriverName + '\n' + item.DriverContactNo,
          dataType: 'entry'
        }
      })
    }
    return newData
  }

  const addGrandTotalRow = (columns, rows) => {
    if (selectedTab !== 0 || !rows.length) return rows

    const grandTotalRow = columns.reduce((acc, column) => {
      acc[column.dataKey] = ''
      return acc
    }, { isGrandTotal: true, dataType: 'total' })

    const captionColumn = columns[1]?.dataKey || columns[0]?.dataKey
    if (captionColumn) {
      grandTotalRow[captionColumn] = dm.grandTotal || 'Grand Total'
    }

    columns.forEach((column) => {
      const { dataKey, xlCol } = column
      if (dataKey === 'srNo' || xlCol?.dataType !== 'number') return

      const total = rows.reduce((sum, row) => {
        const value = Number(row[dataKey])
        return Number.isFinite(value) ? sum + value : sum
      }, 0)

      grandTotalRow[dataKey] = total.toFixed(2)
    })

    return [...rows, grandTotalRow]
  }

  const newPdfMethods = {
    getPdfTableBody
  }
  const generateEXEPrintFormat = (pdfTableData, isSave) => {
    try {
      const pdfColumns = columnDefsForExeFormat.map((col) => {
        return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
      });
      setIsPdfLoaded(false);

      jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
      jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

      const doc = new jsPDF({
        orientation: 'p',
        format: [1240, 1754],
        unit: 'px',
      });

      doc.autoTableSetDefaults({
        headStyles: { fontSize: 14, FontFace: 'Roboto', width: 'auto', halign: 'left', fillColor: '#BFE1FF' },
      })

      doc.setProperties({
        title: `DeliveryMemo.pdf`,
        subject: dm.deliveryMemoSubject || 'Delivery Memo',
        author: 'Maven Tech Labs Pvt. Ltd.',
        keywords: 'maven tech, Cargo system, DeliveryMemo',
        creator: 'MTLPL',
      })
      var totalPagesExp = '{total_pages_count_string}'
      const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
        const doc = data.doc
        // Footer
        var pageSize = doc.internal.pageSize
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

        var str = `${dm.page || 'Page'} : ` + doc.internal.getNumberOfPages()
        if (typeof doc.putTotalPages === 'function') {
          str = str + ' of ' + totalPagesExp
        }
        doc.setFontSize(16)
        doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
        doc.setFont('Roboto', 'bold')
        doc.text(`${dm.reportBy || 'Report By'} : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
        doc.text(`${dm.reportTime || 'Report Time'} : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`${dm.reportTime || 'Report Time'} : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
      }
      autoTable(doc, {
        margin: { top: 180, left: 30, right: 30, bottom: 60 },
        startY: 180,
        alternateRowStyles: {
          fillColor: [255, 255, 255],
        },
        theme: 'grid',
        columns: pdfColumns,
        showHead: 'everyPage',
        rowPageBreak: 'avoid',
        styles: {
          cellPadding: { top: 6, right: 6, bottom: 6, left: 6 },
          minCellHeight: 35,
          valign: 'top',
          lineWidth: [1, 0, 1, 0],
          textColor: '#000000'
        },
        headStyles: {
          fontSize: 16,
        },
        body: pdfTableData,
        tableLineWidth: 0.6,
        columnStyles: exeColumnStyles,
        didParseCell: function (data) {
          var rows = data.table.body
          if (data.row.raw?.isGrandTotal) {
            data.cell.styles.fontStyle = 'bold';
            data.cell.styles.valign = 'middle';
          }
          if (data.row.section === 'head') {
            if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
              data.cell.styles.halign = "right";
            } else {
              data.cell.styles.halign = "left";
            }
          }
        },

        didDrawPage: function (data) {
          // ===== COMPANY HEADER =====
          doc.setTextColor(0, 0, 0)
          doc.setFontSize(30).setFont("Roboto", 'bold')

          doc.text(
            loginData.strCompanyName,
            doc.internal.pageSize.width / 2,
            75,
            { align: 'center' }
          )

          // ===== SUB TITLE =====
          doc.setFontSize(22).setFont("Roboto", 'bold')
          doc.text(
            loginData?.strBranchName,
            doc.internal.pageSize.width / 2,
            105,
            { align: 'center' }
          )

          doc.text(
            dm.deliveryMemoReport || 'Delivery Memo Report',
            doc.internal.pageSize.width / 2,
            145,
            { align: 'center' }
          )
          doc.setFontSize(14)
          doc.setFont('Roboto', 'bold')

          doc.text(
            `${dm.generationDate || 'Generation Date'} : ${moment().format('DD-MMM-YYYY hh:mm A')}`,
            30,
            170
          )

          doc.text(
            `${dm.reportDate || 'Report Date'} : ${moment().format('DD-MMM-YYYY')}`,
            doc.internal.pageSize.width - 30,
            170,
            { align: 'right' }
          )
          jsPdfHeaderFooter(data, loginData, totalPagesExp);
        }
      })
      doc.setFont('Roboto')
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp)
      }
      setIsPdfLoaded(true);
      if (isSave) {
        doc.save(`${tabLabels[selectedTab]} ${new Date().getTime()}.pdf`)
        setTimeout(() => {
          const pdfUrl = doc.output('bloburl')
          document.getElementById('deliveryMemoOutput').data = pdfUrl
          // document.getElementById('deliveryMemoOutput').data = doc.output('datauristring', 'DeliveryMemo.pdf')
          focusElemnt('pdfBack')
        }, 1000)
      } else {
        setTimeout(() => {
          const pdfUrl = doc.output('bloburl')
          document.getElementById('deliveryMemoOutput').data = pdfUrl
          focusElemnt('pdfBack')
        }, 1000)
      }
    } catch (err) {
      console.log(err)
      setIsPdfLoaded(false)
    }
  }
  const generatePdf = (isSave, id) => {
    let pdfColumns = [];
    let pdfTableData = []
    switch (selectedTab) {
      case 0:
        pdfColumns = getCompanyColumnDefsOneA().map((col) => ({
          header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, width: col.width
        }))
        pdfTableData = getPdfTableBody(id)
        break
      case 1:
        pdfColumns = visibleCols(columnDefsTwoA).map((col) => ({
          header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, width: col.width
        }))
        pdfTableData = getPdfTableBody()
        break
      case 2:
        pdfColumns = visibleCols(columnDefsThreeA).map((col) => ({
          header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, width: col.width
        }))
        pdfTableData = getPdfTableBody()
        break
    }

    if (selectedTab === 0 && (loginData?.intCompanyID === SAMAY_TRAVEL || loginData?.intCompanyID === TULSI_TRAVEL)) {
      generateEXEPrintFormat(pdfTableData, isSave)
      return
    }

    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

    const doc = new jsPDF({ orientation: 'p', format: [1240, 1754], unit: 'px' })
    doc.setProperties({
      title: `DeliveryMemo.pdf`,
      subject: dm.deliveryMemoSubject || 'Delivery Memo',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, DeliveryMemo',
      creator: 'MTLPL',
    })

    const totalPagesExp = '{total_pages_count_string}'

    const customFunction = (data, doc) => {
      doc.setTextColor(40)
      doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
      doc.setFontSize(26).setFont("Roboto", 'bold')
      doc.setTextColor(16, 79, 162)
      doc.text(dm.cargoSystemDeliveryMemo || 'Cargo System | Delivery Memo', 90, 80)
      doc.setTextColor(0, 0, 0)
      doc.setFontSize(22).setFont("Roboto", 'normal')
      doc.text(`${dm.companyName || 'Company Name'} :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
      var pageHeight = doc.internal.pageSize.height
      var str = 'Page : ' + doc.internal.getNumberOfPages()
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }
      doc.setFontSize(16).setFont('Roboto', 'bold')
      doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, 'right')
      doc.text(`Report By : ${loginData.strUserName} [ ${loginData.strBranchName} ]`, 30, pageHeight - 5)
      doc.text(`${dm.reportTime || 'Report Time'} : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`,
        (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`${dm.reportTime || 'Report Time'} : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90,
        pageHeight - 5)
    }

    const allCriteriaHeaders = criteriaHeaders.map(col => ({
      header: col.header,
      dataKey: col.field,
      width: 236,
      xlCol: { dataType: 'string', dataFormatter: null }
    }))

    const allCriteriaData = [{
      ...criteriaData,
      ...Object.fromEntries(
        Object.entries(appliedMoreFilter).map(([key, val]) => [key, Array.isArray(val) ? val.join(', ') : val])
      )
    }]

    try {
      setIsPdfLoaded(false)

      const n = 5
      const numOfTables = Math.ceil(allCriteriaHeaders.length / n)
      let start = 120

      for (let i = 0; i < numOfTables; i++) {
        const slice = allCriteriaHeaders.slice(i * n, (i + 1) * n)
        const sliceData = [{ ...allCriteriaData[0], dataType: 'entry' }]
        makeTable(doc, autoTable, slice, sliceData, 1, dm.deliveryMemo || 'Delivery Memo', loginData, 'everyPage', customFunction, start, false, true)
        start = doc.lastAutoTable.finalY + 15
      }

      const startY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 40 : 185
      makeTable(doc, autoTable, pdfColumns, addGrandTotalRow(pdfColumns, pdfTableData), 1, dm.deliveryMemo || 'Delivery Memo', loginData, 'everyPage', customFunction, startY, false, true)

      doc.setFont('Roboto')
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp)
      }
      setIsPdfLoaded(true)
      if (isSave) {
        doc.save(`${tabLabels[selectedTab]} ${new Date().getTime()}.pdf`)
      }
      setTimeout(() => {
        const pdfUrl = doc.output('bloburl')
        document.getElementById('deliveryMemoOutput').data = pdfUrl
        focusElemnt('pdfBack')
      }, 1000)
    } catch (err) {
      console.log(err)
      setIsPdfLoaded(false)
    }
  }
  
  const printClick = (param, id) => {
    if (id === 0) {
      setIsPdfLoaded(false)
      generatePdf(param, id)
    } else if (id === 1 && selectedLrs.length > 0) {
      setIsPdfLoaded(false)
      generatePdf(param, id)
    } else {
      updateAlertError({ show: true, msg: dm.pleaseSelectAtleastOneLr || 'Please Select Atleast One LR', nextId: '' })
    }
  }

  const onLrClick = (rowData) => {
    setClickedBookingID(rowData?.BookingID)
    setDeliveryInputLrNumber(rowData?.LRNO || '')
    setDeliveryShowDrop(true)
    setDeliveryActiveDrop(true)
    // updateSelectedActivity(delivery)
    // setSearchParams({ view: delivery, autoLr: 1 })
    setDeliveryPopup(true)
  }
  useEffect(() => {
    if (lrDetailsData.hasOwnProperty(clickBookingId)) {
      // setShowLRDetails(true)
    }
  }, [lrDetailsData])
  const bulkDeliveryData = {
    bulkDeliveryCheck,
    reciverName,
    reciverPhone,
    selectedRecIdType,
    ReIdNumber,
    selectedMOP,
    selectedParty,
    selectedVehicle,
    remarks,
    selectedLrs,
    vehicleList,
    getIdProof,
    // methodOfPayment: methodOfPayment?.Data?.Table || [],
    MOPList,
    partyList,
    loginData,
    appliedMoreFilter,
    memoFromDate,
    memoToDate,
    showMore,
    checkboxStates,
    excelData,
    setexcelData
  }
  const bulkDeliveryDataTwo = {
    appliedMoreFilter,
    tableData,
    loginData,
    memoFromDate,
    memoToDate,
    bulkDeliveryCheck,
    selectedLrs,
    brnchForDelivery,
    trnsfrVehicle,
    driverName,
    remark,
    brnchList,
    driverInfo,
    vehicleList,
    showMore
  }
  const validateTransfer = () => {
    if (selectedLrs?.length < 1) {
      updateAlertError({ show: true, msg: error.SELECT_LR })
    } else if (brnchForDelivery.BranchID === '') {
      updateAlertError({ show: true, msg: error.TRANSFER_TO_BRANCH, nextId: 'memoBrnchForDeliveryTransfer' })
    } else if (trnsfrVehicle.VehicleID === '') {
      updateAlertError({ show: true, msg: error.TRANSFER_BY_VEHICLE, nextId: 'memoTrnsfrByVehicleNo' })
    } if (remark === '') {
      updateAlertError({ show: true, msg: dm.enterTransferRemark || 'Enter Transfer Remark', nextId: 'memoTrnsfrRemark' })
    } else {
      setShowConfirmationTwo(true)
    }
  }
  const validateDelivery = () => {
    if (!Array.isArray(selectedLrs) || selectedLrs?.length === 0) {
      updateAlertError({ show: true, msg: dm.pleaseSelectSomeLrForDelivery || 'Please Select Some Lr for Delivery', nextId: 'memoGenerate' })
    }
    else if (reciverName === '') {
      updateAlertError({ show: true, msg: error.RECIPIENT_NAME, nextId: 'memoDeliveryReceiver' })
    } else if (reciverPhone === '' && HasContactNoCompulsory === 1) {
      updateAlertError({ show: true, msg: error.RECIPIENT_CONTACT, nextId: 'memoDeliveryReceiverPhone' })
    } else if (reciverPhone.length < 10) {
      updateAlertError({ show: true, msg: error.RECIPIENT_CONTACT_LENGTH, nextId: 'memoDeliveryReceiverPhone' })
    }
    // else if (selectedRecIdType.IDProof === '') {
    //   updateAlertError({ show: true, msg: 'Please select the Id Proof Type', nextId: 'memoDeliveryReceiverIdType' })
    // } else if (ReIdNumber === '') {
    //   updateAlertError({ show: true, msg: 'Please Enter the Id Proof Number', nextId: 'memoDeliveryReceiverIdNumber' })
    // } 
    else if (selectedMOP?.ModeName === '') {
      updateAlertError({ show: true, msg: dm.pleaseSelectModeOfPayment || 'Please Select the Mode of Payment', nextId: 'memoDeliveryMop' })
    } else if (selectedVehicle?.VehicleNo === '') {
      updateAlertError({ show: true, msg: dm.pleaseSelectVehicleNo || 'Please Select the Vehicle No', nextId: 'memoDeliveryVehicle' })
    } else {
      setShowConfirmation(true)
    }
  }
  const bulkDeliveryMehtods = {
    setBulkDeliveryCheck,
    setRecieverName,
    setReceiverPhone,
    setselectedRecIdType,
    setReIdNumber,
    setSelectedMOP,
    setSelectedParty,
    setSelectedVehicle,
    setRemarks,
    setSelectedLrs,
    setTableData,
    bulkDeliver: validateDelivery,
    onLrClick,
    updateSelectedList,
    handleIdProofInput,
    setCheckboxStates,
    updateAlertError
  }
  const bulkDeliverymethodsTwo = {
    bulkDeliverTwo: validateTransfer,
    setSelectedLrs,
    setBrnchForDelivery,
    setTrnsfrVehicle,
    setDriverName,
    setRemark,
    updateSelectedList1
  }
  const confirmationMsg = selectedLrs?.length === 1 ? (dm.areYouSureDeliverSelectedLr || 'Are you sure you want to Deliver selected LR?') : (dm.areYouSureBulkDeliver || 'Are You sure you want to bulk Deliver?')
  const ShowBulkDeliveryConfirmation = () => {
    const data = {
      successMessage: confirmationMsg,
      otherMessage: '',
      buttonId1: '',
      buttonId2: '',
      yesAction: () => { bulkDeliver(); setShowConfirmation(false) },
      noAction: () => setShowConfirmation(false)
    }
    return <SuccessPopUp data={data} updateModal={setShowConfirmation} />
  }
  const ShowDeliveredTicketPrintConfirmation = () => {
    const data = {
      successMessage: dm.doYouWantPrintDeliveredLrDetails || 'Do you want to print the details of LR delivered?',
      otherMessage: '',
      buttonId1: '',
      buttonId2: '',
      yesAction: printDeliveredTickets,
      noAction: closeDeliveredTicketPrint,
      yesDefault: true,
    }
    return <SuccessPopUp data={data} updateModal={closeDeliveredTicketPrint} />
  }
  const confirmTrnsfrMsg = selectedLrs?.length === 1 ? (dm.areYouSureTransferSelectedLr || 'Are you sure you want to Transfer selected LR?') : (dm.areYouSureBulkTransfer || 'Are You sure you want to bulk Transfer?')
  const ShowBulkTransferConfirmation = () => {
    const data = {
      successMessage: confirmTrnsfrMsg,
      otherMessage: '',
      buttonId1: '',
      buttonId2: '',
      yesAction: () => { bulkDeliverTwo(); setShowConfirmationTwo(false) },
      noAction: () => setShowConfirmationTwo(false)
    }
    return <SuccessPopUp data={data} updateModal={setShowConfirmationTwo} />
  }
  const ShowLRDetails = () => {
    const chosenData = lrDetailsData?.[clickBookingId]
    const { Table, Table1 } = chosenData
    const consignmntData = [
      {
        slctdCnsgnmntType: { SubType: Table[0].SubType },
        description: Table[0].Description,
        unit: Table[0].Quantity,
        goods_value: Table[0].GoodsValue,
        wt_actual: Table[0].ActualWeight,
        wt_volume: Table[0].Volume,
        wt_charge: Table[0].ChargedWeight,
        rate: Table[0].Rate,
        freight: Table[0].Freight,
        wt_vlm_len: '0',
        wt_vlm_wid: '0',
        wt_vlm_ht: '0',
        unitType: 'MM',
        action: '',
        slctdMethodOfPckgType: { MOPName: Table[0].mop },
      },
    ]
    const priceSectionData = {
      freight: '0',
      coll_cartage: Table1[0].CollCartage,
      del_cartage: Table1[0].DeliveryCartage,
      hamali: Table1[0].HamaliCharges,
      op_hamali: Table1[0].OperatorHamaliChg,
      valuation: Table1[0].Insurance,
      doc_fee: Table1[0].DocumentCharges,
      pickup_fee: Table1[0].PickupCharge,
      dropoff_fee: Table1[0].DropOffCharge,
      gst: Table1[0].gst,
      CCBrkup_pckp: 0,
      CCBrkup_cmsn: 0,
      CCBrkup_rtrn: 0,
      gross_amount: Table1[0].NetAmount,
    }

    const data = {
      headTxt: dm.lrDetails || 'LR Details',
      hideContols: true,
      consignmntData,
      priceSectionData,
      strtCity: { CityName: Table1[0].SourceCity },
      strtBrnch: { BranchName: Table1[0].SourceBranch },
      sendMobNo: Table1[0].SenderMobileNo,
      sendName: Table1[0].Sender,
      senGstnNo: Table1[0].SenderGSTN,
      senCNnST: Table1[0].SenderAddress,
      destCity: { CityName: Table1[0].DestinationCity },
      destBrnch: { BranchName: Table1[0].DestinationBranch },
      recMobNo: Table1[0].RecMobileNo,
      recName: Table1[0].RecName,
      recGstnNo: Table1[0].ReceiverGSTN,
      recCNnST: Table1[0].RecAddress,
      consignerCheck: false,
      consigneeCheck: false,
      selBookingType: { name: Table1[0].PaymentType },
      slctdSndParty: {},
      slctdRcvrParty: {},
      billNo: Table1[0].PartyBillNo,
      billDate: moment(new Date(Table1[0].PartyBillDate)).isValid() ? moment(new Date(Table1[0].PartyBillDate)) : '',
      billAmount: Table1[0].PartyBillAmt,
      ModalData: {
        send: {
          IdProof: false,
          IdProofType: {
            IDProof: false
          },
          IdProofFile: false
        }
      },
      sendMobNo2: Table1[0].SenderAltNo,
      sendMailId: Table1[0].SenderEmailID,
      recMobNo2: Table1[0].RecvAltNo,
      recMailId: Table1[0].ReceiverEmailID,
      pickupAddressObj: {},
      ewayBillNoList: Table1[0].EWayBillNo ? Table1[0].EWayBillNo.split(',') : [],
      CCR: Table1[0].Comments,
      cmnt: Table1[0].Comments,
      deliveryAddressObj: {},
      ewayBillDetailsList: [],
      DefaultCurrencyID
    }
    return <BookingConfirm data={data} updateModal={() => { setShowLRDetails(false); setClickedBookingID(false); }} />
  }
  const handleExcelExport = () => {
    if (selectedTab === 2) {
      const excelHeaders = visibleCols(columnDefsThree).map(col => ({ header: col.exportHead, field: col.field, textAlign: col.textAlign, ...col.xlCol }))
      const span1 = [Math.ceil(excelHeaders.length / 2), Math.floor(excelHeaders.length / 2)]
      const header1 = [[
        { header: `Delivery Memo: Pending My Delivery At Other Branch`, field: '', span: span1[0], mainHeader: true },
        { header: `Company Name : ${loginData.strCompanyName}`, field: '', span: span1[1] },
      ]]
      const criteriaHeadersTab2 = criteriaHeaders.map(col => ({ header: col.header, field: col.field, dataType: 'string', textAlign: col.textAlign }))

      exportToExcel({
        fileName: `${tabLabels[2]} ${moment().format('DD-MMM-YYYY HH:mm')}.xlsx`,
        sheetName: tabLabels[2],
        headersList: [header1, criteriaHeadersTab2, excelHeaders],
        dataList: [[], [criteriaData], tableData.map(row => ({
          ...row,
          DriverName: `${row.DriverName} - ${row.DriverContactNo}`
        }))]
      })
    } else if (selectedTab === 1) {
      const excelHeaders = visibleCols(columnDefsTwo).map(col => ({ header: col.exportHead, field: col.field, textAlign: col.textAlign, ...col.xlCol }))
      const span1 = [Math.ceil(excelHeaders.length / 2), Math.floor(excelHeaders.length / 2)]
      const header1 = [[
        { header: `Delivery Memo: Pending Other Delivery At My Branch`, field: '', span: span1[0], mainHeader: true },
        { header: `Company Name : ${loginData.strCompanyName}`, field: '', span: span1[1] },
      ]]
      const criteriaHeadersTab1 = criteriaHeaders.map(col => ({ header: col.header, field: col.field, dataType: 'string', textAlign: col.textAlign }))
      exportToExcel({
        fileName: `${tabLabels[1]} ${moment().format('DD-MMM-YYYY HH:mm')}.xlsx`,
        sheetName: tabLabels[1],
        headersList: [header1, criteriaHeadersTab1, excelHeaders],
        dataList: [[], [criteriaData], tableData.map(row => {
          const isSelected = isValueinObjectArray(selectedLrs, row?.BookingID, 'BookingID')
          return {
            ...row,
            BranchForDeliveryTransfer: isSelected ? brnchForDelivery?.BranchName || '' : '',
            TransferByVehicleNo: isSelected ? trnsfrVehicle?.VehicleNo || '' : '',
            DriverName: isSelected ? driverName?.DriverConductorName || '' : '',
            TransferRemarks: isSelected ? remark || '' : '',
          }
        })]
      })
    }
    else if (selectedTab === 0) {
      const excelHeaders = visibleCols(columnDefsOneExcel)
        .map(col => ({ header: col.exportHead, field: col.field, textAlign: col.textAlign, ...col.xlCol }))
      const span1 = [Math.ceil(excelHeaders.length / 2), Math.floor(excelHeaders.length / 2)]
      const header1 = [[
        { header: `Delivery Memo: Pending Delivery At My Branch`, field: '', span: span1[0], mainHeader: true },
        { header: `Company Name : ${loginData.strCompanyName}`, field: '', span: span1[1] },
      ]]
      const criteriaHeadersTab0 = criteriaHeaders.map(col => ({ header: col.header, field: col.field, dataType: 'string', textAlign: col.textAlign }))
      exportToExcel({
        fileName: `${tabLabels[0]} ${moment().format('DD-MMM-YYYY HH:mm')}.xlsx`,
        sheetName: tabLabels[0],
        headersList: [header1, criteriaHeadersTab0, excelHeaders],
        dataList: [[], [criteriaData], excelData]
      })
    }
  }
  return (
    <Box className="delivery-memo">
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <StyledTabs
            aria-label="basic tabs example"
            value={selectedTab}
            onChange={handleTabChange}
            sx={{ backgroundColor: '#e5f3fe', height: '49px' }}
            className="delivery-memo-tabs"
          >
            <Tab
              sx={{
                '&.Mui-focusVisible': {
                  border: 0,
                },
              }}
              label={tabLabels[0]}
            />
            <Tab
              sx={{
                '&.Mui-focusVisible': {
                  border: 0,
                },
              }}
              label={tabLabels[1]}
            />
            <Tab
              sx={{
                '&.Mui-focusVisible': {
                  border: 0,
                },
              }}
              label={tabLabels[2]}
            />
          </StyledTabs>
        </Box>
        <Box sx={{ maxHeight: '100%', height: '100%', overflowY: 'scroll' }}>
          <DeliveryMemoFilter
            handleGenerate={handleGenerate}
            getFilter={getFilter}
            setIsShowAllLRs={setIsShowAllLRs}
            deliveryMemoList={deliveryMemoList}
            tableData={deliveryMemoData}
            setTableData={setTableData}
            deliveryMemoData={deliveryMemoData}
            filters={filters}
            setFilterHeight={setFilterHeight}
            memoFilterData={memoFilterData}
            memoFilterMethods={memoFilterMethods}
            getTableInfo={getTableInfo}
            loginData={loginData}
          />
          <Stack
            component={Paper}
            direction="row"
            spacing={2}
            sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
            className="booking-confirmation-section"
          >
            <Box sx={{ width: '100%', height: '2px', background: '#ccc', margin: '0' }}></Box>
          </Stack>
          {!isPdfLoaded ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                padding: intCompanyID === GUJRAT_COMPANY_ID ? '10px 5px' : '10px',
                marginTop: '-5px',
                background: '#fff',
                display: isExpanded ? 'block' : 'none',
                height: `calc(100% - ${filterheight}px)`,
              }}
            >
              <Box sx={{ ...sx.itemsx, justifyContent: 'space-between', marginLeft: '5px' }}>
                <Box sx={{ fontWeight: 'bold', color: '#444444' }}>{tabLabels[selectedTab]}</Box>
                <Box sx={{ ...sx.itemsx, alignItems: 'flex-end' }}>
                  <Button
                    id="memoPrintBtn"
                    startIcon={<PrintIcon />}
                    variant="contained"
                    color="primary"
                    style={{ ...transparentStyle(theme), fontSize: '12px' }}
                    onClick={() => {
                      printClick(false, 0)
                    }}
                    onKeyDown={(e) => navigation1(e, 'memeoShortPrint', showMore ? 'memoNext2' : 'memoToggleFilter')}
                  >
                    {dm.print || 'Print'}
                  </Button>
                  <Divider
                    orientation="vertical"
                    flexItem
                    style={{ width: '2px', margin: '0', height: '15px', alignSelf: 'center', backgroundColor: '#ccc' }}
                  />
                  <Button
                    id="memeoShortPrint"
                    startIcon={<PrintShortIcon />}
                    variant="contained"
                    color="primary"
                    style={{ ...transparentStyle(theme), fontSize: '12px' }}
                    onClick={() => {
                      printClick(false, 1)
                    }}
                    onKeyDown={(e) => navigation1(e, 'memoExcelBtn', 'memoPrintBtn')}
                  >
                    {dm.shortPrint || 'Short Print'}
                  </Button>
                  <Divider
                    orientation="vertical"
                    flexItem
                    style={{ width: '2px', margin: '0', height: '15px', alignSelf: 'center', backgroundColor: '#ccc' }}
                  />

                  <Grid item xs={6} md={2}>
                    <Button
                      id="memoExcelBtn"
                      startIcon={<ExcelIcon />}
                      variant="contained"
                      color="primary"
                      style={{ ...transparentStyle(theme), fontSize: '12px' }}
                      onClick={(e) => {
                        e.preventDefault()
                        handleExcelExport()
                      }}
                      onKeyDown={(e) => navigation1(e, 'memoExportPdfBtn', 'memeoShortPrint')}
                    >
                      {dm.exportAsExcel || 'EXPORT AS EXCEL'}
                    </Button>
                    <ReactHtmlTableToExcel
                      id="xls-button-memo"
                      table="delivery-memo-excel-tbl"
                      filename={tabLabels[selectedTab]}
                      sheet={dm.sheet1 || 'sheet 1'}
                      buttonText={dm.exportAsExcel || 'EXPORT AS EXCEL'}
                      className="excel-button"
                    />
                  </Grid>
                  <Divider
                    orientation="vertical"
                    flexItem
                    style={{ width: '2px', margin: '0', height: '15px', alignSelf: 'center', backgroundColor: '#ccc' }}
                  />
                  <Button
                    id="memoExportPdfBtn"
                    startIcon={<PdfIcon />}
                    variant="contained"
                    color="primary"
                    style={{ ...transparentStyle(theme), fontSize: '12px' }}
                    onClick={(e) => {
                      printClick(true, selectedLrs.length > 0 ? 1 : 0)
                    }}
                    onKeyDown={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      navigation3(e, selectedTab === 0 || selectedTab === 1 ? 'memoTablerowCheck0' : 'memoFromDate', 'memoExcelBtn', () =>
                        printClick(true)
                      )
                    }}
                  >
                    {dm.exportAsPdf || 'Export As PDF'}
                  </Button>
                </Box>
              </Box>
              {selectedTab === 0 && (
                <DeliveryMemoTable
                  tableData={tableData}
                  selectedLRs={selectedLrs}
                  selectedTab={selectedTab}
                  data={bulkDeliveryData}
                  methods={bulkDeliveryMehtods}
                />
              )}
              {selectedTab === 1 && <DeliveryMemoTableTwo data={bulkDeliveryDataTwo} methods={bulkDeliverymethodsTwo} />}
              {selectedTab === 2 && (
                <DeliveryMemoTableThree
                  tableData={tableData}
                  deliveryMemoData={deliveryMemoData}
                  setTableData={setTableData}
                  loginData={loginData}
                  memoFromDate={memoFromDate}
                  memoToDate={memoToDate}
                  moreFilter={moreFilter}
                  appliedMoreFilter={appliedMoreFilter}
                  showMore={showMore}
                />
              )}
              {/* </Box> */}
            </Box>
          ) : (
            <Box style={{ position: 'relative', width: '100%', height: '100%' }}>
              {
                <object
                  id="deliveryMemoOutput"
                  type="application/pdf"
                  width="100%"
                  height="100%"
                  style={{ marginTop: '50px' }}
                  title={dm.pendingDeliveryTitle || 'MTLPL - Pending Delivery'}
                  aria-label={dm.pendingDeliveryAria || 'MTLPL - CARGO - Delivery Memo'}
                ></object>
              }
              <Button
                id="pdfBack"
                className="btn add-btn"
                variant="contained"
                color="error"
                style={{ position: 'absolute', top: '5px', right: '10px' }}
                onClick={() => {
                  backToScreenView()
                }}
                onKeyDown={(e) => {
                  navigation3(e, 'memoFromDate', 'pdfBack', () => {
                    setIsPdfLoaded(false)
                    focusElemnt('memoGenerate')
                  })
                }}
              >
                {dm.back || 'BACK'}
              </Button>
            </Box>
          )}
          <Stack
            component={Paper}
            direction="row"
            spacing={2}
            sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
            className="booking-confirmation-section"
          >
            <Box sx={{ width: '100%', height: '2px', background: '#ccc', margin: '0' }}></Box>
          </Stack>
        </Box>
        {isExpanded && selectedTab === 0 && (
          <DeliveryMemoBottom1 data={bulkDeliveryData} methods={bulkDeliveryMehtods} updateAlertError={updateAlertError} />
        )}
        {isExpanded && selectedTab === 1 && <DeliveryMemoBottom2 data={bulkDeliveryDataTwo} methods={bulkDeliverymethodsTwo} />}
        {showConfirmation && <ShowBulkDeliveryConfirmation />}
        {showDeliveryPrintConfirmation && <ShowDeliveredTicketPrintConfirmation />}
        {showConfirmationTwo && <ShowBulkTransferConfirmation />}
        {showLRDetails && <ShowLRDetails />}
        {modal === 'loaderModal' && <LoaderModel list={cityListData} />}
        {deliveryPopup && <Modal headTxt={dm.cargoDelivery || 'Cargo | Delivery'} width="100%" height="100%" modalTop="-40px" updateModal={setDeliveryPopup}> < Delivery isPopup={true} handleGenerate={handleGenerate} /></Modal>}
      </Box>
    </Box>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  updateAlertError,
  getDeliveryMemo,
  getDriverList,
  getVehicleList,
  getIDProofList,
  GetMOFPaymentUpdate,
  getLrDetailsWIthBookingID,
  updateLoader,
  updateSelectedActivity
}

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryMemo)
